import {translation} from "./translation";
import { Routes } from '@angular/router';
import {HymnReaderComponent} from "./hymn-reader/hymn-reader.component";
import {HymnPresenterComponent} from "./hymn-presenter/hymn-presenter.component";
import {GuessTheHymnComponent} from "./guess-the-hymn/guess-the-hymn.component";

export const routes: Routes = [
  { path: '', component: HymnReaderComponent },
  { path: translation.path_hymn + '/:reference', component: HymnReaderComponent },
  { path: translation.path_present + '/:reference', component: HymnPresenterComponent },
  { path: translation.path_guess_the_hymn, component: GuessTheHymnComponent },
];
